import React from 'react';
import PrimaryButton from './../../Components/Presentation/PrimaryButton/PrimaryButton';

class GeneralConfiguration extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = { 
      name: props.user!== null? props.user.get("name"): "",
      email: props.user !== null? props.user.get("email"):"",
      address:props.user !== null? props.user.get("address"):""
    };
  }

  onSave = async () => {
    this.setState({isLoading:true});
    
    const{name, address} = this.state;
    const {user} = this.props;

    user.set("name", name);
    user.set("address", address);
    await user.save();

    this.setState({isLoading:false});
  }

  render() {
    const {name, email, address, isLoading} = this.state;
    const loading = isLoading ? 
                    <div className="loadingScreen">
                        <div className="lds-dual-ring"></div>
                    </div> 
                    : 
                    null;   

    return (
      <div className="row">
        {loading}
        <div className="vertical-separator-8px"></div>
        
        <div className="col-md-6 col-md-offset-3">
          <h4>Datos de la cuenta</h4>
        </div>

        <div className="vertical-separator-8px"></div>

        <div className="col-md-6 col-md-offset-3 form-group">
          <label>Email</label>
          <input 
            type="text" 
            className="form-control" 
            value={email}
            disabled></input>
        </div>

        <div className="vertical-separator-8px"></div>

        <div className="col-md-6 col-md-offset-3 form-group">
          <label>Nombre</label>
          <input 
            type="text" 
            className="form-control"
            value={name}
            onChange={(evt)=> {this.setState({name: evt.target.value})}}
          ></input>
        </div>

        <div className="vertical-separator-8px"></div>

        <div className="col-md-6 col-md-offset-3 form-group">
          <label>Dirección de recepción</label>
          <input 
            type="text" 
            className="form-control"
            value={address}
            onChange={(evt)=> {this.setState({address: evt.target.value})}}
          ></input>
        </div>

        <div className="vertical-separator-24px"></div>

        <div className="col-md-4 col-md-offset-4 text-center">
          <PrimaryButton
            onClick={this.onSave}
            text="Guardar"
          ></PrimaryButton>
        </div>

      </div>
    )
  }

  componentDidMount() {
    this.setState({ someKey: 'otherValue' });
  }
}

export default GeneralConfiguration;



// WEBPACK FOOTER //
// ./src/views/Account/Configuration/GeneralConfiguration.js